<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ 'base.edit_company' | translate }}
    v-card-content
      v-input-r(
        :label="$t('base.company_name_2')"
        :hint="errorMessage"
        :invalid="!!errorMessage"
        :pattern="'.{1,100}'"
        v-model="form.name"
        @blur="validateName")
    v-card-actions
      v-btn(
        :disabled="!form.name"
        :loading="loading"
        @click="onSave")
        | {{ 'base.save' | translate }}
</template>

<script>
import api from '@/api'

export default {
  name: 'EditModal',

  props: {
    selected: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    form: {},
    error: null,
    loading: false
  }),

  computed: {
    errorMessage () {
      if (!this.error) return null

      const errorMessages = {
        required: 'Поле обов\'язкове для заповнення',
        maxLength: `Максимальна довжина: 100 символів`
      }

      return errorMessages[this.error] || this.error
    }
  },

  watch: {
    'form.name' (newValue) {
      if (this.error && newValue && newValue.length > 0 && newValue.length <= 100) {
        this.error = null
      }
    }
  },

  mounted () {
    this.form = { ...this.selected }
  },

  methods: {
    validateName () {
      this.error = null

      if (!this.form.name || this.form.name.trim() === '') {
        this.error = 'required'
        return false
      }

      if (this.form.name.length > 100) {
        this.error = 'maxLength'
        return false
      }

      return true
    },

    forceValidation () {
      this.validateName()

      if (this.error) {
        const inputComponent = this.$children.find(child => child.$options.name === 'VInputR')
        if (inputComponent) {
          inputComponent.hasBlurred = true
        }
      }
    },

    async onSave () {
      this.forceValidation()

      if (this.error) {
        return
      }

      this.loading = true
      const { id, ...payload } = this.form
      const { errors } = await api.companies.updateById(id, payload)
      this.loading = false

      if (!errors) {
        this.$emit('update')
        this.$emit('close')
      } else {
        this.$toasted.error(this.$t('errors.incorrect_data'))
      }
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>